module.exports = ".header-nav {\n  position: fixed;\n  left: 100px;\n  z-index: 3;\n  width: 100%; }\n\n.my-settings-bold {\n  font-weight: bold; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/vendor.component.scss
// module id = ./src/app/pages/vendor/vendor.component.scss
// module chunks = main